var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-slice-text-clamp overflow-hidden",class:{
        'gst-slice-text-clamp--clamped': _vm.clamped,
    },style:(_vm.style)},[_vm._t("default"),(_vm.clamped)?_c('div',{staticClass:"gst-slice-text-clamp__fade"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }